import { formatOrderNumber } from "../../OrdersList/order-list-utils";
import { badgeForStatus } from "../../../../../features/orders/orderStatus";
import SupplierReceipt from "../SupplierReceipt";
import MasterPaymentCard from "../MasterPaymentCard";
import ReviewButtonCard from "../OrderSideDetail/ReviewButtonCard";

const SupplierSection = ({ section, index, total, aggregateStatus }) => {
  const heading = `Supplier ${index + 1} of ${total} — Order #${section.orderNumber}`;

  if (!section.detail) {
    return (
      <section className="ord-panel ord-receipt is-loading">
        <span className="ord-receipt-heading">{heading}</span>

        <p className="ord-receipt-pending">
          {section.errored
            ? `Could not load ${section.supplier?.name || "this supplier"}.`
            : `Loading ${section.supplier?.name || "supplier"}…`}
        </p>
      </section>
    );
  }

  const differs = section.detail.status !== aggregateStatus;

  return (
    <SupplierReceipt
      detail={section.detail}
      supplier={section.supplier}
      heading={heading}
      badge={differs ? badgeForStatus(section.detail.status) : null}
      showPayment={false}
      showTotal={false}
    >
      {section.detail.ratable && (
        <ReviewButtonCard
          supplier={section.supplier}
          title={`Add a Review for ${section.supplier?.name || "supplier"}`}
        />
      )}
    </SupplierReceipt>
  );
};

const MasterOrderSummary = ({
  master,
  masterRef,
  sections,
  aggregate,
}) => {
  const badge = badgeForStatus(aggregate?.status);
  const supplierCount = masterRef?.subOrderCount || sections.length;
  const lead = sections.find((section) => section.detail)?.detail;

  return (
    <>
      <section className="ord-panel ord-panel-compact">
        <div className="ord-panel-head ord-order-head">
          <span className="ord-card-number">
            {formatOrderNumber(master?.orderNumber || masterRef?.orderNumber)}
          </span>

          <span className="ord-chip">{supplierCount} suppliers</span>

          {lead && (
            <span className="ord-placed-at">
              {lead.placedDate} | {lead.placedTime}
            </span>
          )}

          {badge && (
            <span className={`ord-status ord-status-${badge.tone}`}>
              {badge.label}
            </span>
          )}
        </div>

        {master && (
          <>
            <div className="ord-receipt-rule" />

            <MasterPaymentCard master={master} supplierCount={supplierCount} />
          </>
        )}
      </section>

      {sections.map((section, index) => (
        <SupplierSection
          key={section.id}
          section={section}
          index={index}
          total={supplierCount}
          aggregateStatus={aggregate?.status}
        />
      ))}
    </>
  );
};

export default MasterOrderSummary;
